import React from "react";

const InputField = (props) => {
  const {  type, errorCondition, errorText } = props;
  return (
   
      <div className="mr-3">
        <input {...props} className="appearance-none block w-full text-gray-700 border-2 border-gray-300 py-2 px-4 leading-tight focus:outline-none focus:bg-white" type={type} />
        {errorCondition && <p className="text-red-600 text-xs">{errorText}</p>}
      </div>
 
  );
};

export default InputField;